window.addEventListener("DOMContentLoaded",()=>{
    let faq = document.querySelector('.questions');
    if(faq){
        //get answer height
        let answers = faq.querySelectorAll('.answer')
        answers.forEach(answer =>{
            answer.setAttribute('style',`--tooltip-height:${answer.scrollHeight}px`)
        })
        //update height when resize
        window.addEventListener('resize', ()=>{
            answers.forEach(answer =>{
                answer.setAttribute('style','height:auto')
                answer.setAttribute('style', `--tooltip-height:${answer.scrollHeight}px`);
            })
        })

        //heading click
        let faq_items = faq.querySelectorAll('.question-item');
        faq_items.forEach(item =>{
            item.querySelector('.question').addEventListener("click",()=>{
                item.classList.toggle('active');
            })
        })
    }
})
